import { computed } from 'vue';

import { useFlagStore } from '@/stores/flag';

export function useYouTubeCompliance() {
  const flagStore = useFlagStore();

  const youTubeMetricsAllowed = computed(
    () => flagStore.ready && Boolean(flagStore.flags.youtubeCompliance),
  );

  const hideYouTubeMetrics = computed(() => !youTubeMetricsAllowed.value);

  const hideForYouTube = (isYouTube: boolean | null | undefined): boolean =>
    Boolean(isYouTube) && hideYouTubeMetrics.value;

  return { youTubeMetricsAllowed, hideYouTubeMetrics, hideForYouTube };
}
